<template>
  <div class="wrapper">
    <!-- Mobile overlay -->
    <div class="sidebar-overlay" :class="{ active: sidebarOpen }" @click="closeSidebar"></div>

    <!-- Sidebar -->
    <div class="sidebar-custom" :class="{ 'sidebar-open': sidebarOpen }">
      <div class="sidebar-content">
        <div class="sidebar-header">
          <div class="brand-wrapper">
            <div class="brand-logo-box">P</div>
            <div class="brand-text">
              <span class="brand-name">PROFCAR</span>
              <span class="brand-version">v{{ appVersion }}</span>
            </div>
          </div>
          <div class="id-badge">ID: {{ sklads.secret_code }}</div>

          <!-- TIL ALMASHTIRISH -->
          <div class="lang-switch">
            <button type="button" :class="['lang-btn', { active: $i18n.locale === 'uz' }]" @click="changeLang('uz')">
              O'ZB
            </button>
            <button type="button" :class="['lang-btn', { active: $i18n.locale === 'ru' }]" @click="changeLang('ru')">
              РУС
            </button>
          </div>
        </div>

        <div class="sidebar-nav-container">
          <side-bar>
            <template slot="links">
              <div class="menu-section">
                <sidebar-item :link="{ name: 'Bosh sahifa', icon: 'bi bi-pie-chart-fill', path: '/' }" />
                <div class="menu-divider" v-if="anyVisible(['/chiqim/index','/chiqim/pos','/zakazlar/index','/ombor','/reviziyalar','/kirim/index','/qaytarilganlar'])">{{ $t('SAVDO') }}</div>
                <sidebar-item v-if="canSee('/chiqim/index')" :link="{ name: 'Savdolar ro\'yxati', icon: 'bi bi-list-check', path: '/chiqim/index' }" />
                <sidebar-item v-if="canSee('/chiqim/pos')" :link="{ name: 'Savdo (POS)', icon: 'bi bi-calculator-fill', path: '/chiqim/pos' }" class="pos-item" />
                <sidebar-item v-if="canSee('/zakazlar/index')" :link="{ name: 'Zakazlar', icon: 'bi bi-journal-check', path: '/zakazlar/index' }" />
                <sidebar-item v-if="canSee('/ombor')" :link="{ name: 'Ombor (Qoldiq)', icon: 'bi bi-boxes', path: '/ombor' }" />
                <sidebar-item v-if="canSee('/reviziyalar')" :link="{ name: 'Reviziyalar tarixi', icon: 'bi bi-clipboard-check', path: '/reviziyalar' }" />
                <sidebar-item v-if="canSee('/kirim/index')" :link="{ name: 'Ta\'minot (Kirim)', icon: 'bi bi-truck', path: '/kirim/index' }" />
                <sidebar-item v-if="canSee('/qaytarilganlar')" :link="{ name: 'Qaytarilganlar', icon: 'bi bi-arrow-counterclockwise', path: '/qaytarilganlar' }" />

                <div class="menu-divider" v-if="anyVisible(['/kassaorder/index','/safe/index','/balans-transfer/index','/nasiyalar','/usta/index'])">{{ $t('MOLIYA') }}</div>
                <sidebar-item v-if="canSee('/kassaorder/index')" :link="{ name: 'Kassa order (Kirim/Chiqim)', icon: 'bi bi-cash-coin', path: '/kassaorder/index' }" />
                <sidebar-item v-if="canSee('/safe/index')" :link="{ name: 'Seyf', icon: 'bi bi-safe2', path: '/safe/index' }" />
                <sidebar-item v-if="canSee('/balans-transfer/index')" :link="{ name: 'Balans o\'tkazish', icon: 'bi bi-arrow-left-right', path: '/balans-transfer/index' }" />
                <sidebar-item v-if="canSee('/nasiyalar')" :link="{ name: 'Nasiyalar', icon: 'bi bi-cash-stack', path: '/nasiyalar' }" />
                <sidebar-item v-if="canSee('/usta/index')" :link="{ name: 'Ustalar', icon: 'bi bi-person-badge-fill', path: '/usta/index' }" />

                <div class="menu-divider" v-if="anyVisible(['/xisobot/main','/xisobot/masters','/xisobot/master-sverka'])">{{ $t('BOSHQARUV') }}</div>
                <sidebar-item v-if="canSee('/xisobot/main')" :link="{ name: 'Hisobot', icon: 'bi bi-pie-chart-fill', path: '/xisobot/main' }" />
                <sidebar-item v-if="canSee('/xisobot/masters')" :link="{ name: 'Ustalar hisoboti', icon: 'bi bi-person-badge', path: '/xisobot/masters' }" />
                <sidebar-item v-if="canSee('/xisobot/master-sverka')" :link="{ name: 'Usta sverka', icon: 'bi bi-calculator', path: '/xisobot/master-sverka' }" />

                <div class="menu-divider" v-if="anyVisible(['/paket/index','/brand/index','/malumot/dollar/index','/model/index','/malumot/kontragent/index','/taminotchi/index','/directory/product/index','/offers','/contact','/malumot/sklad/index','/malumot/user/index','/malumot/paytype/index'])">{{ $t("Ma'lumotlar") }}</div>
                <sidebar-item v-if="canSee('/paket/index')" :link="{ name: 'Paketlar', icon: 'bi bi-box-seam', path: '/paket/index' }" />
                <sidebar-item v-if="canSee('/brand/index')" :link="{ name: 'Brendlar', icon: 'bi bi-box-seam', path: '/brand/index' }" />
                <sidebar-item v-if="canSee('/malumot/dollar/index')" :link="{ name: 'Kurs', icon: 'bi bi-box-seam', path: '/malumot/dollar/index' }" />
                <sidebar-item v-if="canSee('/model/index')" :link="{ name: 'Modellar', icon: 'bi bi-box-seam', path: '/model/index' }" />
                <sidebar-item v-if="canSee('/malumot/kontragent/index')" :link="{ name: 'Mijozlar', icon: 'bi bi-people-fill', path: '/malumot/kontragent/index' }" />
                <sidebar-item v-if="canSee('/taminotchi/index')" :link="{ name: 'Ta\'minotchilar', icon: 'bi bi-truck-flatbed', path: '/taminotchi/index' }" />
                <sidebar-item v-if="canSee('/directory/product/index')" :link="{ name: 'Maxsulotlar', icon: 'bi bi-people-fill', path: '/directory/product/index' }" />
                <sidebar-item v-if="canSee('/offers')" :link="{ name: 'Takliflar', icon: 'bi bi-bullseye', path: '/offers' }" />
                <sidebar-item v-if="canSee('/contact')" :link="{ name: 'Kontaktlar', icon: 'bi bi-people-fill', path: '/contact' }" />
                <sidebar-item v-if="canSee('/malumot/sklad/index')" :link="{ name: 'Skladlar', icon: 'bi bi-people-fill', path: '/malumot/sklad/index' }" />
                <sidebar-item v-if="canSee('/malumot/user/index')" :link="{ name: 'Foydalanuvchilar', icon: 'bi bi-gear-fill', path: '/malumot/user/index' }" />
                <sidebar-item v-if="canSee('/malumot/paytype/index')" :link="{ name: 'To\'lov turlari', icon: 'bi bi-credit-card-2-front', path: '/malumot/paytype/index' }" />
              </div>
            </template>
          </side-bar>
        </div>
      </div>
    </div>

    <!-- Main Panel -->
    <div class="main-panel" :style="mainPanelStyle">
      <!-- Top Bar -->
      <div class="topbar">
        <button
          class="toggle-btn"
          type="button"
          @click="toggleSidebar"
          :title="sidebarOpen ? 'Menyuni yopish' : 'Menyuni ochish'"
          :aria-label="sidebarOpen ? 'Menyuni yopish' : 'Menyuni ochish'"
        >
          <b-icon :icon="sidebarOpen ? 'chevron-left' : 'list'"></b-icon>
        </button>
        <span class="topbar-title">PROFCAR</span>
      </div>

      <div class="content-view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { version } from '../../../package.json';

export default {
  data() {
    return {
      sklads: { secret_code: "AA" },
      appVersion: version,
      rules: [],
      sidebarOpen: true,
      isDesktop: true,
    };
  },
  computed: {
    mainPanelStyle() {
      return {
        float: 'none',
        width: 'auto',
        marginLeft: (this.isDesktop && this.sidebarOpen) ? '260px' : '0px',
        transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      };
    }
  },
  watch: {
    $route() {
      this.$nextTick(() => window.scrollTo(0, 0));
      // Mobileda sahifa o'zgarganda sideberni yopish
      if (window.innerWidth < 992) {
        this.sidebarOpen = false;
      }
    }
  },
  mounted() {
    this.isDesktop = window.innerWidth >= 992;
    this.sidebarOpen = this.isDesktop;

    window.addEventListener('resize', this.handleResize);

    const savedRules = localStorage.getItem("rules");
    if (savedRules) {
      this.rules = JSON.parse(savedRules);
    }

    axios.get("api/v1/sklads/id/1").then(response => {
      this.sklads = response.data;
    }).catch(err => console.log(err));
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // Foydalanuvchining "Huquqlar" (menu_json) jadvalida shu sahifa uchun "Ko'rish"
    // belgilangan-belgilanmaganini tekshiradi. menu_json'da yozuv umuman bo'lmasa
    // (masalan hali sozlanmagan eski foydalanuvchi) — standart holatda ko'rsatamiz,
    // yozuv mavjud bo'lib "see" false bo'lsa — yashiramiz.
    canSee(path) {
      let menuJson = null;
      try {
        menuJson = JSON.parse(localStorage.getItem('menu_json'));
      } catch (e) {
        menuJson = null;
      }
      if (!menuJson || typeof menuJson !== 'object' || !menuJson[path]) return true;
      return !!menuJson[path].see;
    },
    anyVisible(paths) {
      return paths.some(p => this.canSee(p));
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    // Til almashtirish: i18n.locale ni o'zgartiradi (butun UI qayta render bo'ladi)
    // va tanlovni store + localStorage ga saqlaydi.
    changeLang(lang) {
      if (this.$i18n.locale === lang) return;
      this.$i18n.locale = lang;
      this.$store.commit('SET_LOCALE', lang);
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 992;
      if (this.isDesktop) {
        this.sidebarOpen = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ─── Sidebar ───────────────────────────────────────────────────────────────
.sidebar-custom {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 260px;
  background-color: #0f172a;
  z-index: 1050;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  transform: translateX(-260px);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.sidebar-open {
    transform: translateX(0);
  }

  .sidebar-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

// ─── Sidebar Header ────────────────────────────────────────────────────────
.sidebar-header {
  padding: 24px 20px 16px;

  .brand-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;

    .brand-logo-box {
      background: #2563eb;
      color: white;
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      font-weight: 800;
      font-size: 22px;
    }

    .brand-name {
      color: white;
      font-weight: 800;
      font-size: 19px;
      font-style: italic;
      display: block;
    }

    .brand-version {
      color: #10b981;
      font-size: 10px;
      font-weight: 800;
      display: block;
    }
  }

  .id-badge {
    opacity: 0.6;
    font-size: 10px;
    margin-top: 6px;
    color: #94a3b8;
  }

  .lang-switch {
    display: flex;
    gap: 4px;
    margin-top: 14px;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 10px;
    padding: 4px;

    .lang-btn {
      flex: 1;
      border: none;
      background: transparent;
      color: #94a3b8;
      font-weight: 800;
      font-size: 12px;
      letter-spacing: 0.5px;
      padding: 7px 0;
      border-radius: 7px;
      cursor: pointer;
      transition: all 0.18s;

      &:hover:not(.active) {
        color: #fff;
        background: rgba(255, 255, 255, 0.08);
      }

      &.active {
        background: #2563eb;
        color: #fff;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4);
      }
    }
  }
}

// ─── Sidebar Nav ───────────────────────────────────────────────────────────
.sidebar-nav-container {
  flex: 1;
  overflow-y: auto;
  padding: 10px 15px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #334155;
    border-radius: 4px;
  }
}

.menu-divider {
  padding: 20px 15px 10px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

// ─── Sidebar Items (global override) ──────────────────────────────────────
::v-deep {
  .sidebar-nav-container .nav > li > .nav-link {
    color: #cbd5e1 !important;

    .sidebar-normal,
    svg {
      color: inherit !important;
    }

    &:hover,
    &:focus,
    &:active {
      background: rgba(255, 255, 255, 0.1) !important;
      color: #ffffff !important;
    }
  }

  .sidebar-nav-container .nav > li.router-link-active > .nav-link,
  .sidebar-nav-container .nav > li > .nav-link.router-link-active,
  .sidebar-nav-container .nav > li > .nav-link.router-link-exact-active {
    background: #2563eb !important;
    color: #ffffff !important;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  }

  .sidebar-item {
    margin-bottom: 3px;

    .nav-link {
      color: #94a3b8 !important;
      padding: 10px 15px !important;
      border-radius: 10px !important;
      display: flex;
      align-items: center;
      transition: background 0.15s, color 0.15s;

      p {
        margin: 0 !important;
        font-size: 14px;
        font-weight: 600 !important;
      }

      i {
        font-size: 17px;
        margin-right: 12px;
        width: 20px;
        text-align: center;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.06) !important;
        color: #e2e8f0 !important;
      }
    }

    &.active > .nav-link {
      background: #2563eb !important;
      color: white !important;
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    }
  }
}

// ─── Mobile Overlay ────────────────────────────────────────────────────────
.sidebar-overlay {
  display: none;

  @media (max-width: 991px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 1040;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;

    &.active {
      opacity: 1;
      pointer-events: all;
    }
  }
}

// ─── Topbar ────────────────────────────────────────────────────────────────
.topbar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 20px;
  height: 56px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  .toggle-btn {
    border: none;
    cursor: pointer;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    color: #ffffff;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, box-shadow 0.15s, transform 0.15s;
    flex-shrink: 0;
    background: #2563eb;

    svg {
      width: 20px;
      height: 20px;
      color: #ffffff;
    }

    &:hover {
      background: #1d4ed8;
      box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
      transform: translateY(-1px);
    }

    &:focus {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }
  }

  .topbar-title {
    font-weight: 800;
    font-style: italic;
    font-size: 16px;
    color: #1e293b;

    // Desktop da sidebar ochiq bo'lganda title ko'rinmasin
    @media (min-width: 992px) {
      display: none;
    }
  }
}

// ─── Main Panel ────────────────────────────────────────────────────────────
.main-panel {
  min-height: 100vh;
  background: #f8fafc;
  // margin-left va transition inline :style orqali boshqariladi
}

.content-view {
  padding: 0;
}
</style>
